export const LANGUAGES = {
  en: {
    label: "English",
    stt: "en-US",
    femaleVoice: "Joanna",
    maleVoice: "Matthew",
    grammar: "en-US"
  },
  fr: {
    label: "French",
    stt: "fr-FR",
    femaleVoice: "Celine",
    maleVoice: "Mathieu",
    grammar: "fr-FR"
  },
  de: {
    label: "German",
    stt: "de-DE",
    femaleVoice: "Marlene",
    maleVoice: "Hans",
    grammar: "de-DE"
  },
  es: {
    label: "Spanish",
    stt: "es-ES",
    femaleVoice: "Conchita",
    maleVoice: "Enrique",
    grammar: "es-ES"
  },
  it: {
    label: "Italian",
    stt: "it-IT",
    femaleVoice: "Carla",
    maleVoice: "Giorgio",
    grammar: "it-IT"
  },
  ja: {
    label: "Japanese",
    stt: "ja-JP",
    femaleVoice: "Mizuki",
    maleVoice: "Takumi",
    grammar: "ja-JP"
  }
};